export default __webpack_public_path__ + "static/media/dots2.efd9b11c.svg";